
























































































































































































































































import { Vue, Component, Watch, Emit } from 'vue-property-decorator';
import AMSBreadcrumb from '@/components/AMSBreadcrumb.vue';
import AMSUpload from '@/components/AMSUpload.vue';
import request from '@/utils/request';
import AMSTable from '@/components/AMSTable.vue';
import AMSProductCategorySelector from '@/components/AMSProductCategorySelector.vue';
import AMSSelectedProduct from '@/components/AMSSelectedProduct.vue';
import { AppStore } from '@/store/modules/app';
import AMSBrandSelector from '@/components/AMSBrandSelector.vue';
import { productBrandList } from '@/api/product';
import AMSDialog from '@/components/AMSDialog.vue';
import Utils from '@/utils/utils';
import { emptyRule, regRule } from '@/utils/rules';
interface ProductLinks {
  linkedProductId?: string;
  linkType?: 'Recommand';
  sort?: number;
}
interface Form {
  productLinks?: ProductLinks[];
  name?: string;
  serialNumber?: string; //商品编号
  categoryId?: string | string[]; //商品品牌的id 《必填》
  sort?: number | null; //排序值
  brandId?: string | undefined; // -品牌Guid  选填
  status?: boolean | string; //是否上架
  isHidden?: boolean | string; //是否隐藏商品
  capacity?: string; //容量
  stockWarningValue?: number; //库存预警值
  miniOrderQuantity?: number; //起订量
  packingNumber?: number; //装箱数
  orderPrice?: number; //订货价  《必填》
  costPrice?: number; //成本价
  retailPrice?: number; //零售价
  description?: string; //--描述 少于200字符
  pictures?: object; //图片
  id?: string | (string | null)[]; //修改时产品id
  capacityUnitId?: number;
}
@Component({
  components: {
    'ams-breadcrumb': AMSBreadcrumb,
    'ams-product-category-selector': AMSProductCategorySelector,
    'ams-upload': AMSUpload,
    'ams-table': AMSTable,
    'ams-brand-selector': AMSBrandSelector,
    'ams-dialog': AMSDialog
  }
})
export default class AddProduct extends Vue {
  valid: Boolean = true;
  brandList: any = [];
  form: Form = {
    brandId: '',
    pictures: [],
    sort: 100,
    capacity: '',
    miniOrderQuantity: 1,
    stockWarningValue: 0,
    isHidden:false
  };
  tabValue: number = 0;
  productLinks: Array<Object> = [{}];
  breadItems: any = [];
  headers = [
    { text: '序号', value: 'number', isSort: true, align: 'left'},
    {
      text: '商品',
      value: 'name',
      align: 'left',
      render: (h: Function, param: any) => {
        return h(AMSSelectedProduct, {
          props: {
            items: param,
            selectedItems: this.productLinks,
            isMoreBtn: true,
            isOnSale: true
          },
          on: {
            select: (value: Array<object>) => {
              this.productLinks.splice(param.index, 1, ...value);
            },
            autoComplete: (value: Object) => {
              this.productLinks.splice(param.index, 1, value);
            }
          }
        });
      }
    },
    { text: '容量', value: 'capacity', align: 'left' },
    {
      text: '订货价',
      value: 'orderPrice',
      align: 'right'
    },
    {
      text: '操作',
      value: 'actions',
      align: 'center',
      isActions: true
    }
  ];
  maxLength = 9;
  capacityUnitId?: string = '';
  productId?: string | (string | null)[];
  getCapacityList = [{ id: 0, capacityName: '不选择' }];
  confirmDialog: boolean = false;
  confirmLoading: boolean = false;
  status: boolean = false;
  isfCostPrice: boolean = false; //成本价valid
  isfRetailPrice: boolean = false; //零售价valid
  addloading: Boolean = false;
  get canManage() {
    return Utils.isPermission('ProductManager.ProductsList.UpdateStatus');
  }
  created() {
    this.productId = this.$route.query.id;
    this.breadItems = [
      {
        text: '商品管理',
        disabled: false,
        href: '/productManage'
      },
      {
        text: '商品列表',
        disabled: false,
        href: '/productManage'
      },
      {
        text: this.$route.query.id ? '修改商品' : '新增商品',
        disabled: true
      }
    ];
    if (this.productId) {
      this.init(this.productId);
    } else {
      this.capacityUnitId = '不选择';
    }
    this.getCapacity();
  }
  changeProductName(value: string) {
    this.form.name = value.replace(/^\s*/g, '');
  }

  // 表单正则
  changeSort(event: any) {
    const reg = /^(0|[1-9][0-9]*)?$/;
    if (event.target.value && !reg.test(event.target.value)) {
      event.target.value = 100;
    } else if (event.target.value && event.target.value.length > 9) {
      event.target.value = event.target.value.slice(0, 9);
    }
    this.form.sort = event.target.value;
  }
  changminiOrderQuantity(event: any) {
    const reg = /^([1-9][0-9]*)?$/;
    if (event.target.value == 0) {
      event.target.value = 1;
    } else if (event.target.value && !reg.test(event.target.value)) {
      event.target.value = 1;
    } else if (event.target.value && event.target.value.length > 9) {
      event.target.value = event.target.value.slice(0, 9);
    }
    this.form.miniOrderQuantity = event.target.value;
  }
  changpackingNumber(event: any) {
    const reg = /^([1-9][0-9]*)?$/;
    if (event.target.value == 0) {
      event.target.value = 1;
    } else if (event.target.value && !reg.test(event.target.value)) {
      event.target.value = 1;
    } else if (event.target.value && event.target.value.length > 9) {
      event.target.value = event.target.value.slice(0, 9);
    }
    this.form.packingNumber = event.target.value;
  }
  changeStockWarningValue(event: any) {
    const reg = /^(0|[1-9][0-9]*)?$/;
    if (event.target.value == 0) {
      event.target.value = 0;
    } else if (event.target.value && !reg.test(event.target.value)) {
      event.target.value = '';
    } else if (event.target.value && event.target.value.length > 9) {
      event.target.value = event.target.value.slice(0, 9);
    }
    this.form.stockWarningValue = event.target.value;
  }
  changeorderPrice(event: any) {
    const reg = /(^[1-9](\d+)?(\.\d{1,2})?$)|(^\d\.\d{1,2}$)/;
    if (event.target.value == 0 || event.target.value < 0) {
      event.target.value = '';
    }
    // else if (event.target.value && !reg.test(event.target.value)) {
    //   if (event.target.value.indexOf('.') >= 0) {
    //     event.target.value = Number(event.target.value.split('.')[0] + '.' + event.target.value.split('.')[1].slice(0, 2));
    //   }
    // }
    else if (event.target.value && event.target.value.length > 9) {
      event.target.value = event.target.value.slice(0, 9);
    }
    this.form.orderPrice = event.target.value;
  }
  changeorderPriceInput(value: any) {
    if (value == 0) {
      value = '';
    } else if (value && value.length > 9) {
      value = value.slice(0, 9);
    }
  }
  changecostPriceInput(value: any) {
    const reg = /(^[1-9](\d+)?(\.\d{1,2})?$)|(^\d\.\d{1,2}$)/;
    if (value == 0) {
      this.isfCostPrice = true;
      value = '';
    } else if (value && !reg.test(value)) {
      this.isfCostPrice = true;
    } else if (value && value.length > 9) {
      value = value.slice(0, 9);
    } else {
      this.isfCostPrice = false;
    }
  }
  changecostPrice(event: any) {
    if (!event.target.value) {
      this.isfCostPrice = false;
      return;
    }
    const reg = /(^[1-9](\d+)?(\.\d{1,2})?$)|(^\d\.\d{1,2}$)/;
    if (event.target.value == 0) {
      this.isfCostPrice = true;
      event.target.value = '';
    } else if (event.target.value && !reg.test(event.target.value)) {
      this.isfCostPrice = true;
    } else if (event.target.value && event.target.value.length > 9) {
      event.target.value = event.target.value.slice(0, 9);
    } else {
      this.isfCostPrice = false;
    }

    this.form.costPrice = event.target.value;
  }
  changeretailPriceInput(value: any) {
    const reg = /(^[1-9](\d+)?(\.\d{1,2})?$)|(^\d\.\d{1,2}$)/;
    if (value == 0) {
      this.isfRetailPrice = true;
      value = '';
    } else if (value && !reg.test(value)) {
      this.isfRetailPrice = true;
    } else if (value && value.length > 9) {
      value = value.slice(0, 9);
    } else {
      this.isfRetailPrice = false;
    }
  }
  changeretailPrice(event: any) {
    if (!event.target.value) {
      this.isfRetailPrice = false;
      return;
    }
    const reg = /(^[1-9](\d+)?(\.\d{1,2})?$)|(^\d\.\d{1,2}$)/;
    if (event.target.value == 0) {
      this.isfRetailPrice = true;
      event.target.value = '';
    } else if (event.target.value && !reg.test(event.target.value)) {
      this.isfRetailPrice = true;
    } else if (event.target.value && event.target.value.length > 9) {
      event.target.value = event.target.value.slice(0, 9);
    } else {
      this.isfRetailPrice = false;
    }
    this.form.retailPrice = event.target.value;
  }
  // tabChange
  changeAddPro(value: number) {
    this.tabValue = value;
  }
  getCapacity() {
    productBrandList().then((response: any) => {
      this.brandList = response.items;
    });
    request.get(`/api/Product/Capacity/List`).then((data: any) => {
      this.getCapacityList = [{ id: 0, capacityName: '不选择' }, ...data.items];
    });
  }
  init(id: string | (string | null)[]) {
    const self = this;
    request.get(`/api/Product/${id}`).then((data: any) => {
      self.form = data;
      this.form.status = data.status === 'OnSale' ? true : false;
      data.productLinks.map((ele: any) => {
        self.productLinks.push(ele.linkedProduct);
      });
      if (data.productLinks.length > 0) {
        self.productLinks.splice(0, 1);
      }
    });
  }
  add(index: number, key: string) {
    if (this.productLinks.length <= 9) {
      this.productLinks.splice(index + 1, 0, {});
    } else {
      AppStore.ShowWarning('列表数据已满10条，请删除后再添加！',2000);
    }
  }
  remove(index: number, key: string) {
    this.productLinks.splice(index, 1);
    if (this.productLinks.length == 0) {
      this.productLinks.push({});
    }
  }
  textChange(list: any[]) {
    this.productLinks = list;
  }
  /**选中商品分类 */
  get categoryRules() {
    if (this.form.categoryId == undefined || this.form.categoryId == '') {
      const rule = (v: string) => {
        return '请选择商品分类';
      };
      return [rule];
    } else {
      return [];
    }
  }
  confirmClose() {
    this.confirmDialog = false;
  }
  isExist() {
    request
      .get('/api/Product/CheckNameAndCapacityExist', {
        name: this.form.name,
        capacity: this.form.capacity ? `${this.form.capacity}${this.capacityUnitId === '不选择' ? '' : this.capacityUnitId}` : '',
        id: this.productId ? this.productId : ''
      })
      .then((data: any) => {
        if (data) {
          this.confirmDialog = data;
        } else {
          this.saveAll();
        }
      });
  }
  confirmSure() {
    this.confirmDialog = false;
    this.saveAll();
  }
  saveAll() {
    if (this.isfRetailPrice || this.isfCostPrice) {
      this.tabValue = 0;
      return;
    }
    if (!(this.$refs.productCategoryForm as any).validate()) {
      this.tabValue = 0;
      return;
    } else {
      this.addloading = true;
      this.form.status = this.status ? 'OnSale' : 'StopSale';
      this.form.stockWarningValue = this.form.stockWarningValue ? this.form.stockWarningValue : 0;
      this.form.miniOrderQuantity = this.form.miniOrderQuantity ? this.form.miniOrderQuantity : 1;
      this.form.packingNumber = this.form.packingNumber ? this.form.packingNumber : 1;
      this.form.capacity = this.form.capacity ? `${this.form.capacity}${this.capacityUnitId === '不选择' ? '' : this.capacityUnitId}` : '';
      let arr: any[] = [];
      this.productLinks.forEach((value: any) => {
        if (value.id) {
          let data = { linkedProductId: value.id, linkType: 'Recommand', sort: value.index };
          arr.push(data);
        }
      });
      this.form.productLinks = arr;
      if (this.productId) {
        this.form.id = this.productId;
      }
      let formData = Object.assign({}, this.form);
      if (!this.productId) {
        request
          .post('/api/Product/CreateOrEdit', formData)
          .then(() => {
            AppStore.ShowSuccess('保存成功！');
            this.$router.push('/productManage');
            this.addloading = false;
          })
          .catch((error: any) => {
            this.form.capacity = this.form.capacity ? `${this.form.capacity.split(String(this.capacityUnitId))[0]}` : '';
            AppStore.ShowError(`保存失败！${error.error.validationErrors[0].message}`);
            this.addloading = false;
          });
      } else {
        request
          .post('/api/Product/CreateOrEdit', formData)
          .then(() => {
            AppStore.ShowSuccess('修改成功！');
            this.$router.push('/productManage');
            this.addloading = false;
          })
          .catch((error: any) => {
            this.addloading = false;
            AppStore.ShowError(`修改失败！${error.error.validationErrors[0].message}`);
          });
      }
    }
       Utils.clearAllSearchPage(this.$route.name as string);
  }
  goBack() {
    this.$router.go(-1);
  }
  @Watch('isfCostPrice', { immediate: true, deep: true })
  isfCostPriceChange(value: any, oldValue: any) {
    this.isfCostPrice = value;
  }
  @Watch('isfRetailPrice', { immediate: true, deep: true })
  isfRetailPriceChange(value: any, oldValue: any) {
    this.isfRetailPrice = value;
  }
}
